import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Container, Tab, LinearProgress } from "@mui/material";
import { useState, SyntheticEvent } from "react";
import { useSelector } from "react-redux";
import { useQueryPartialSum } from "services/api/queries/useQueryPartialSum";
import { useQueryUserOrdersPending } from "services/api/queries/useQueryUserOrdersPending";
import { useQueryUserOrdersFinished } from "services/api/queries/useQueryUserOrdersFinished";
import { IPartialSumParams } from "types/UserOrder";
import { useSearchParams } from "react-router-dom";
import logger from "components/Logger"
import { ICardapioAppState } from "../../redux/RootReducer";
import { TableOrderDetailsCard, OrderSkeleton, OrderList } from "components/OrderDetails";

const path = 'src/pages/Orders/index.tsx'

const Abas = {
  emAndamento: 'andamento',
  concluidos: 'concluidos'
}

function Orders() {

  const [abaAtual, setAbaAtual] = useState(Abas.emAndamento);
  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);
  const placeInfo = useSelector((state: ICardapioAppState) => state?.placeInfo);

  const [searchParams] = useSearchParams();
  const table = searchParams.get("table");
  // const customOriginQrCode = searchParams.get("origin")

  const params: IPartialSumParams = {
    user_id: loginInfo?.id ?? -1,
    data: new Date().toISOString().split("T")[0],
    time: new Date().toLocaleTimeString("pt-Br", {
      hour: "2-digit",
      minute: "2-digit",
    }),
    place_id: placeInfo?.id ?? -1,
  };

  //apiFinishedOrders
  const apiPartialSum = useQueryPartialSum(params);
  const { data: userOrdersFinishedData,
    isLoading: usersOrdersFinishedIsLoading,
    isRefetching: userOrdersFinishedIsRefetching} = useQueryUserOrdersFinished(loginInfo?.id ?? -1)
  const { data: userOrdersPendingData,
    isLoading: userOrdersPendingIsLoading,
    isRefetching: userOrdersPendingIsRefetching} = useQueryUserOrdersPending(loginInfo?.id ?? -1)

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setAbaAtual(newValue);
  };

  const urlParamsTemMesa =
    table !== null
    && !isNaN(+table)
    && +table > 0

  const isParcialDeMesaOuPedidosPendententesLoading =
    (urlParamsTemMesa && apiPartialSum.isLoading)
    || (!urlParamsTemMesa && userOrdersPendingIsLoading)

  /**
   * se o urlParams tem mesa, vai mostra o parcial da mesa.
   * se não, vai mostrar os pedidos pendentes (que ainda não foram finalizados)
   */
  const mostraPartialDaMesaOuPedidosEmAndamento =
    (urlParamsTemMesa
      ? (<Box>
            <TableOrderDetailsCard parcialItensNotFiltered={apiPartialSum.data?.data} />
          </Box>)
      : <OrderList orders={userOrdersPendingData?.data}/>)

  logger.log('******************************************')
  logger.log('* BEFORE RENDER')
  logger.log(`* FILE: ${path}`)
  logger.log(`* TABLE:`, table)
  logger.log(`* DETECTOU MESA:`, urlParamsTemMesa)
  logger.log(`* VAI RENDERIZAR:`, mostraPartialDaMesaOuPedidosEmAndamento)
  logger.log(`* apiPartialSum:`, apiPartialSum)
  logger.log('******************************************')

  return (
    <Container
      sx={{ height: "(90vh - 60px)", paddingTop: { md: "60px" } }}
      maxWidth="lg"
    >

      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={abaAtual}>
          <Box>
            <TabList
              onChange={handleChange}
              variant="fullWidth"
              sx={{
                marginBottom: (abaAtual===Abas.concluidos)
                  || (abaAtual===Abas.emAndamento && !userOrdersPendingIsRefetching) ? '4px' : 0
              }}
            >
              <Tab
                value={Abas.concluidos}
                label="Concluídos"
                sx={{
                  textTransform: "none",
                  fontWeight: "500",
                }}
              />
              <Tab
                value={Abas.emAndamento}
                label="Em Andamento"
                sx={{
                  textTransform: "none",
                  fontWeight: "500",
                }}
              />
            </TabList>

            {abaAtual===Abas.emAndamento && userOrdersPendingIsRefetching
              && <Box sx={{
                width: '100%',
              }}>
                <LinearProgress />
              </Box>
            }
          </Box>
          <TabPanel value={Abas.concluidos}>

            {
              usersOrdersFinishedIsLoading
                ? <OrderSkeleton/>
                : <OrderList orders={userOrdersFinishedData?.data}/>
            }
          </TabPanel>
          <TabPanel value={Abas.emAndamento}>

            <Box sx={{
              opacity: (userOrdersPendingIsRefetching ? '65%' : '100%'),
            }}>
              {
                isParcialDeMesaOuPedidosPendententesLoading
                  ? <OrderSkeleton />
                  : mostraPartialDaMesaOuPedidosEmAndamento
              }
            </Box>
          </TabPanel>
        </TabContext>

      </Box>
      <Box sx={{ paddingBottom: { xs: 15, md: 0 } }} />
    </Container>
  );
}

export default Orders;
